import { Col, Row, Skeleton } from 'antd';
import { memo } from 'react';
import 'moment/dist/locale/bn';
import { chunk } from 'lodash';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import Caption from '../Caption/Caption';
import { useGetDashboardFooterBottomQuery } from '../Large-footer/Large-footer-bottom/FooterLinksSlice';
import { FooterBottomData } from '../../Admin/Footer-Bottom/store/footerBottomSlice';
import { commonState } from '../../../app/base/commonSlice';

function SmallFooter() {
  const isExtraLargeScreen = useMediaQuery({ minWidth: 2560 });
  const { footerApiCall } = useSelector(commonState);
  const { data: footerBottomData, isLoading: footerBottomDataLoading } =
    useGetDashboardFooterBottomQuery(undefined, {
      skip: isExtraLargeScreen ? false : footerApiCall,
    });

  const footerData =
    // @ts-expect-error
    footerBottomData?.filter((item: FooterBottomData) => item?.is_active) || [];

  const maxNumCols = 2; // Define the maximum number of columns (maximum of 3 in this case)

  const dividedData = chunk(
    footerData,
    Math.ceil(footerData.length / maxNumCols)
  );

  if (footerBottomDataLoading) {
    <Skeleton />;
  }

  return (
    <div>
      <Row className="md:pl-[120px] pl-[20px] pr-[20px] md:pr-[120px] py-8">
        {dividedData?.map((data, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Col span={12} key={index}>
            <div
              className={classNames('flex gap-4 flex-col md:flex-row', {
                'flex justify-end': index === 1,
              })}
            >
              {data?.map((item: any) => {
                return item?.url ? (
                  <a
                    href={item?.url}
                    className="text-gray-500 hover:text-gray-200 underline"
                    target={item?.url.startsWith('http') ? '_blank' : '_self'}
                    rel="noreferrer"
                  >
                    <Caption
                      text_en={item?.title_en}
                      text_bn={item?.title_bn}
                      color="gray-500"
                      fontSize="xl"
                    />
                  </a>
                ) : (
                  <div className="flex items-center gap-2">
                    <Caption
                      text_en={item?.title_en}
                      text_bn={item?.title_bn}
                      color="gray-500"
                      fontSize="xl"
                    />
                  </div>
                );
              })}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default memo(SmallFooter);
